import { FC, useEffect, useMemo, useReducer, useRef } from "react";
// 组件
import { ProSpin } from '../antd';
import DragGrid from "./DragGrid";
import Options from "./Options";
// 方法
import { DragDropContext, DragDropDispatchContext, } from './context/dragDropContext';
import useResizeChange from "../Hooks/useResizeChange";
import dragDropReducer from "./reducer/dragDropReducer";
// 常量
import { STATUS_CREATED, STATUS_CREATED_CODE } from "../constants/constant";
import { DragDropProps, DropfullScreenActionType, IFirstDataProps } from "./interface";
import './style.less';
import DropfullScreen from "./DropfullScreen";

/** 拖拽 */
const DragDrop: FC<DragDropProps> = props => {
  const {
    actionRef, isMove, grid = 12, height = 120, loading, gridConfig, options, isChangeSize,
    onClickOperation, onClickOtherOperation,
  } = props;
  const dragDropRef = useRef<any>({});
  const dropfullScreenRef = useRef<DropfullScreenActionType>(); // 全屏
  const [dragDropStates, dispatch] = useReducer(dragDropReducer, {
    isMove,
    grid,
    height,
    gridConfig,
    isChangeSize,
    dragDropRef,
    dropfullScreenRef,
    onClickOperation,
    onClickOtherOperation,
    dragItems: options ? options.map(item => ({...item, [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] || STATUS_CREATED.DEFAULT})) : [],
    width: 0,
    wrapWidht: 0,
    wrapHeight: 0,
  });
  const containerRef = useRef<HTMLDivElement>(null); // div容器
  const isFirstInit = useRef<IFirstDataProps>({options: true, isMove: true});
  useEffect(() => {
    _getWidth();
  }, []);
  useEffect(() => {
    if (!isFirstInit.current.options) {
      dispatch({ type: 'changeOptions', payload: { dragItems: options || [], }, });
    }
    isFirstInit.current.options = false;
  }, [ options ]);
  useEffect(() => {
    if (!isFirstInit.current.isMove) {
      dispatch({ type: 'changeMove', payload: { isMove, }, });
    }
    isFirstInit.current.isMove = false;
  }, [ isMove ]);
  // 监听窗口变化
  useResizeChange(() => _getWidth());
  /** 获取容器宽度 */
  const _getWidth = () => {
    if (!containerRef.current) return;
    const wrapWidht = containerRef.current.clientWidth;
    const wrapHeight = containerRef.current.clientHeight;
    dispatch({ type: 'changeWrapSize', payload: { wrapWidht, wrapHeight, }, });
  };
  /** 网格 */
  const renderGrid = useMemo(() => {
    if (!dragDropStates.isMove) return null;
    if (dragDropStates.gridConfig === null) return null;
    return (
      <DragGrid />
    );
  }, [ dragDropStates, ]);
  if (actionRef) {
    actionRef.current = {
      fullScreen: (name?: string) => {
        if (name) {
          const findItem = dragDropStates.dragItems.find(item => item.name === name);
          if (findItem) {
            dropfullScreenRef.current?.show(name);
            return;
          }
        }
        const firstName = dragDropStates.dragItems?.[0]?.name;
        if (firstName) {
          dropfullScreenRef.current?.show(firstName);
        }
      },
      getDragItems: () => {
        return dragDropStates.dragItems;
      },
      addDragItem: (dragItem) => {
        dispatch({ type: 'addDragItem', payload: { addDragItem: dragItem, }, });
      },
      deleteDragItem: (dragItemName: string) => {
        dispatch({ type: 'deleteDragItem', payload: { deleteName: dragItemName, }, });
      },
      getDragItemRef: (name: string) => {
        return dragDropRef.current?.[name]?.current;
      },
    };
  }

  return (
    <DragDropContext.Provider value={dragDropStates}>
      <DragDropDispatchContext.Provider value={dispatch}>
        <div className="drag-drop" ref={containerRef}>
          {renderGrid}
          <ProSpin spinning={loading} style={{ width: '100%', height: '100vh', }}>
            <Options />
          </ProSpin>
        </div>
        <DropfullScreen actionRef={dropfullScreenRef} />
      </DragDropDispatchContext.Provider>
    </DragDropContext.Provider>
  );
};

DragDrop.defaultProps = {
  isMove: true,
  isChangeSize: true,
  grid: 12,
  height: 120,
  loading: false,
};

export default DragDrop;
